import React from "react";
import Layout from "Layout";
import Section from "Layout/Section";
import CartBundleComponent from "components/BundlePromotion/CartBundleDashboard";

const CartBundle: React.FC = () => {
  
  return (
    <Layout>
      <Section>
        <CartBundleComponent />
      </Section>
    </Layout>
  );
};

export default CartBundle;